import { migrateBrowserStorage } from '@boltcrm/module-sdk/web';

// Imported first by main.tsx, so it runs before any module reads a saved setting (ADR-1043).
migrateBrowserStorage();
